module.exports = __webpack_public_path__ + "fb30b8dafd99f54d8784001adbdd6d25.jpg";